import { Badge, Box, Button, Flex, Grid, Text, createStyles } from "@mantine/core";

import CustomBreadcrumbs from "../../components/CustomBreadCrumbs";
import { useState } from "react";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  text1: {
    height: "38px",
    fontWeight: 700,
    fontSize: "16px",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title1: {
    display: "flex",

    alignItems: "center",
    justifyContent: "center",
    height: "40px",
  },
  title2: {
    backgroundColor: "#53A0DD",
    display: "flex",
    height: "40px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    padding: "6px 24px 6px 24px",
    color: "#FFFFFF",
    fontWeight:700,
    fontSize:"14px",lineHeight:"21px"
  },
}));
interface Props {
  title?: string;
  colName?: string[];
  inNetworkCopay?: string;
  inNetworkCoINS?: string;
  outNetworkCopay?: string;
  outNetworkCoINS?: string;
  sideTitle1:string;
  sideTitle2:string
}

export const Summary: React.FC<Props> = ({
  title,
  colName,
  inNetworkCoINS,
  inNetworkCopay,
  outNetworkCoINS,
  outNetworkCopay,
  sideTitle1,
  sideTitle2
}) => {
  const { classes } = useStyles();

  return (
    <>
      <Flex
        direction={"column"}
        pt={12}
        sx={{
          border: "1px solid #BEDEF8",
          borderRadius: "8px",
          padding: "12px",
        }}
        bg={"#F1F9FF"}
      >
        <Text
          bg={"#BEDEF8"}
          align="center"
          color="#262930"
          mih={40}
          className={classes.text1}
          sx={{ borderRadius: "4px", padding: "8px 24px 8px 24px" }}
        >
          {title}
        </Text>
        <Box pt={"16px"}>
          <Grid>
            <Grid.Col span={4}></Grid.Col>
            <Grid.Col span={4}>
              <Text
                weight={500}
                size={"14px"}
                color="#474E5B"
                className={classes.title1}
              >
                {colName?.[0]}
              </Text>
            </Grid.Col>
            <Grid.Col span={4}>
              <Text
                weight={500}
                size={"14px"}
                color="#474E5B"
                className={classes.title1}
              >
                {colName?.[1]}
              </Text>
            </Grid.Col>
            <Grid.Col span={4}>
              <Text weight={600} size={14} className={classes.title1}>
                {" "}
                {sideTitle1}
              </Text>
            </Grid.Col>
            <Grid.Col span={4}>
              <Box className={classes.title2}>{inNetworkCopay}</Box>
            </Grid.Col>
            <Grid.Col span={4}>
              <Box className={classes.title2}>{inNetworkCoINS}</Box>
            </Grid.Col>
            <Grid.Col span={4}>
              <Text weight={600} size={14} className={classes.title1}>
                {" "}
                {sideTitle2}
              </Text>
            </Grid.Col>
            <Grid.Col span={4}>
              <Box className={classes.title2}>{outNetworkCopay}</Box>
            </Grid.Col>
            <Grid.Col span={4}>
              <Box className={classes.title2}>{outNetworkCoINS}</Box>
            </Grid.Col>
          </Grid>
        </Box>
      </Flex>
    </>
  );
};
